<template>
  <div class="bishe">
    <navBarNoLab :onIndex='0'></navBarNoLab>
    <div class="content">
        <div class="top1" id="screen1">
            <div class="banner">
                <div class="bannerKey">
                    <div class="rowA"><img src="./images/keyformsImg/rowA.png" width="741px" alt=""></div>
                    <div class="rowB">
                        <img class="img1" src="./images/keyformsImg/rowB1.png" width="137px" height="31.09" alt="">
                        <img class="img2" src="./images/keyformsImg/rowB2.png" width="164px" height="31.09" alt="">
                        <img class="img3" src="./images/keyformsImg/rowB3.png" width="222px" height="31.09" alt="">
                        <img class="img4" src="./images/keyformsImg/rowB4.png" width="163px" height="31.09" alt="">
                    </div>
                    <div class="rowC">
                         <img class="imgfotn1" src="./images/keyformsImg/rowC1.png" alt="">
                         <img class="imgfotn2" src="./images/keyformsImg/rowC2.png" alt="">
                         <img class="imgfotn3" src="./images/keyformsImg/rowC3.png" alt="">
                         <img class="imgfotn4" src="./images/keyformsImg/rowC4.png" alt="">
                         <img class="imgfotn5" src="./images/keyformsImg/rowC5.png" alt="">
                         <img class="imgfotn6" src="./images/keyformsImg/rowC6.png" alt="">
                         <img class="imgfotn7" src="./images/keyformsImg/rowC7.png" alt="">
                         <img class="imgfotn8" src="./images/keyformsImg/rowC8.png" alt="">
                         <img class="imgfotn9" src="./images/keyformsImg/rowC9.png" alt="">
                         <img class="imgfotn10" src="./images/keyformsImg/rowC10.png" alt="">
                         <img class="imgfotn11" src="./images/keyformsImg/rowC11.png" alt="">
                         <img class="imgfotn12" src="./images/keyformsImg/rowC12.png" alt="">
                         <img class="imgfotn13" src="./images/keyformsImg/rowC13.png" alt="">
                         <img class="imgfotn14" src="./images/keyformsImg/rowC14.png" alt="">
                         <img class="imgfotn15" src="./images/keyformsImg/rowC15.png" alt="">
                         <img class="imgfotn16" src="./images/keyformsImg/rowC16.png" alt="">
                         <img class="imgfotn17" src="./images/keyformsImg/rowC17.png" alt="">
                         <img class="imgfotn18" src="./images/keyformsImg/rowC18.png" alt="">
                         <img class="imgfotn19" src="./images/keyformsImg/rowC19.png" alt="">
                    </div>
                </div>
            </div>
            <div class="title">拒绝买买买 做自己的毕设</div>
            <div :class="{cont:true, top1animationkey: top1animation}">
                <div class="leftcont">
                    <div class="information">
                        <img src="./images/img_tongdian.png" alt="">
                    </div>
                </div>
                <div class="play">
                    <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsline="false" :options="playerOptions"></video-player>
                </div>
                <div class="ritcont">
                    <div class="information">
                       <img src="./images/img_shichang.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="top2" id="screen1">
            <div class="placeholderbox">
            <div :class="{topTit: true, scrollTop: fixdTop}">
                <div class="box">
                    <div :class="{act: scInd === 1}" @click="scrollAimsHandle(1)">技巧课程篇</div>
                    <div :class="{act: scInd === 2}" @click="scrollAimsHandle(2)">项目课程篇</div>
                    <div :class="{act: scInd === 3}" @click="scrollAimsHandle(3)">项目素材篇</div>
                </div>
            </div>
            </div>
            <div class="content" id="scrollLab1">
                <div style="height: 70px"></div>
                <div :class="{cont:true, top2animationkey: top2animation}">
                    <div class="line"></div>
                    <div class="title"><img src="./images/img_tag_jiqiaopian.svg" width="106px" alt=""> 毕设大拿带你12小时学会毕设套路 </div>
                    <div class="itemBox" v-for="(item, index) in courseListData" :key="index">
                            <div class="item">
                                <div class="icon"><img v-if="item.icon" :src="item.icon.url" width="32px" alt=""> <div>{{item.icontitle}}</div></div>
                                <div :class="{itemInfo:true,itemInfolast:ind+1 === item.courseList.length}" @click="jiqiaoHandle(it)" :dataInd = "index.toString() + ind.toString() " v-for="(it, ind) in item.courseList" :key="ind">
                                    <img v-if="it.image" :src="it.image.url" width="206px" alt="">
                                    <div>{{it.title}}</div>
                                </div>
                            </div>
                    </div>
                </div>
                <div class="bottom" id="scrollLab2">
                    <div class="tit">
                        <img src="./images/img_tag_xiangmu.svg" width="106" alt="">
                        技术大牛教你如何 24 小时搞定毕设项目
                    </div>
                    <div class="desc">从选题、项目开发到答辩 PPT 设计，全搞定</div>
                </div>
            </div>
        </div>
        <div class="top3" id="top3Position" @mousemove="overHandle" @mouseleave ="outHandle">
            <div class="titleCont">
                <div class="label">
                    <span @click="changeHandle(index)" :class="{act: item.id === top3Index}" v-for="(item, index) in top3data" :key="index">{{item.title}}</span>
                </div>
                <div :class="{cont:true, top3animationkeyfrom: top3animation}" :key="top3Index">
                    <div class="labbox" v-for="(item, index) in top3data[top3Index].cont" :key="index">
                        <div class="icon"><img :src="item.icon" width="72px" alt=""></div>
                        <div class="tit">{{item.name}}</div>
                        <div class="des">{{item.desc}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{top4:true, top4animationkeyfrom: top4animation}"  >
           <div  v-for="(item, index) in bsPageDage" :key="index" :id="'screen4' + index" >
               <div :class="{content: true, noneBut: index+1 == bsPageDage.length}" >
                    <div class="conthead">
                            <div v-if="item.bisheProjectHeand.imgurl"><img :src="item.bisheProjectHeand.imgurl.url" width="316px" height="229px" alt=""></div>
                            <div>
                                <div class="title">{{item.bisheProjectHeand.title}}</div>
                                <div class="label"><span><img src="./images/icon_xiangmu.svg" width="25px" alt="">{{item.bisheProjectHeand.label}}</span></div>
                                <div class="desc">{{item.bisheProjectHeand.desc}}</div>
                            </div>
                    </div>
                    <div class="block">
                            <div class="blockItem" v-for="(it, ind) in item.contdata" :key="ind">
                                    <div class="bk1" v-if="it.type === 1">
                                        <div class="tit" v-if="it.icon"><img :src="it.icon.url" width="46px" alt=""> {{it.title}}</div>   
                                        <div class="cont" v-if="typeof it.cont == 'object'">
                                            <div v-for="(list, num) in it.cont" :key="num">
                                                <div class="name">{{list.title}}</div>
                                                <div v-if="typeof list.description == 'object'">
                                                    <div v-for="(li, n) in list.description" :key="n">{{li}}</div>
                                                </div>
                                                <div v-else>{{list.description}}</div>
                                            </div>
                                        </div> 
                                        <div class="cont" v-else>{{it.description}}</div>
                                    </div>
                                    <div class="bk2" v-if="it.type === 2">
                                        <div class="tit" v-if="it.icon"><img :src="it.icon.url" width="46px" alt=""> {{it.title}}</div>   
                                        <div class="cont">
                                            <div class="listbox" v-for="(list, num) in it.cont" :key="num">
                                                <a class="st" v-if="list.files" :href="list.files.url" target="_blank"> <div class="lab" ><img v-show="list.image" :src="list.image.url"  width="16px" alt="">{{list.title}}</div> </a>
                                                <div class="lab none" v-else ><img v-if="list.image" :src="list.image.url"  width="16px" alt="">{{list.title}}</div>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="bk3" v-if="it.type === 3">
                                        <div class="tit">
                                        <div v-if="it.icon"><img :src="it.icon.url" width="46px" alt=""> {{it.title}}</div> 
                                            <div class="rowBut" v-show="it.cont.length >= 5 ">
                                                <div class="icon iconfont swiper-button-prev">&#xe6da;</div>
                                                <!-- <div class="swiper-pagination"></div> -->
                                                <div class="icon iconfont swiper-button-next">&#xe6d8;</div>
                                            </div>
                                        </div>   
                                        <div class="cont">
                                            <swiper :options="swiperOption" >
                                                    <swiper-slide id="num" :class="{list: true, noMargin: num+1 === it.cont.length}" v-for="(list, num) in it.cont" :key="num" style="width:178px !important;height:180px !important" >
                                                        <a v-if="list" :href="list.url" target="_blank">
                                                            <div><img v-if="list.image" :src="list.image.url" width="100%" alt=""></div>
                                                            <div>{{list.title}}</div>
                                                        </a>
                                                    </swiper-slide>
                                            </swiper>
                                        </div> 
                                    </div>
                            </div>
                    </div>
                    <div class="buttom">
                        <a v-if="item.bisheProjectHeand.learnUrl" :href="item.bisheProjectHeand.learnUrl" target="_blank" ><span class="butleft">开启毕设学习</span> </a>
                        <span v-else class="butleft" @click="qimoChatClick('在线咨询')">开启毕设学习</span>
                        <a v-if="item.bisheProjectHeand.objUrl" :href="item.bisheProjectHeand.objUrl" target="_blank" > <span class="butrit">项目预览</span> </a>
                        <span v-else class="butrit"  @click="qimoChatClick('在线咨询')">项目预览</span>
                    </div>
                </div>
           </div>
        </div>
        <div class="top6" id="screen6">
            <div class="topBanner">
                <div :class="{contInfo: true, top6animationkeyform:top6animation}">
                    <div><img src="./images/img_text.png" width="1145px" alt=""></div>
                    <a href="http://yun.itheima.com/" target="_blank"><div><span>马上去学</span></div></a>
                </div>
            </div>
            <div class="contbox" id="scrollLab3">
                <div class="title"><img src="./images/img_tag_sucai.svg" width="106px" alt=""> 技巧给你，项目教你，前沿主流的项目素材也都在这里</div>
                <div class="desc">快来做你的专属毕设吧!</div>
                <div :class="{itembox: true, top6animationkeyform:top61animation}">
                    <div :class="{materiallist:true, last: index === 3 || index === 7}" v-for="(item , index) in materialData" :key="index">
                        <div class="tit">{{item.title}}</div>
                        <div class="des">{{item.cont}}</div>
                         <a v-if="item.url && index == 0" :href="item.url"><div class="down" ><span>立即下载</span></div></a>
                        <div v-else class="down" @click="qimoChatClick('在线咨询')"><span>联系咨询获取</span></div>
                    </div>
                    <!-- <div class="materiallistlast">
                        <div class="des">
                            <div><img src="./images/icon_yasuobao.png" width="53px" alt=""></div>
                            <div>更多优质素材等你来拿</div>
                        </div>
                        <div class="down"><span>解锁更多</span></div>
                    </div> -->
                </div>
                <div class="downloadBut" @click="qimoChatClick('在线咨询')"><span>联系咨询获取全部</span></div>
            </div>
        </div>
        <div class="top7" id="screen7">
            <div :class="{title: true, top6animationkeyform:top7animation}">关于我们</div>
            <div :class="{label: true, top6animationkeyform:top7animation}"> <span> - A股教育行业上市公司 - </span></div>
            <div :class="{contBox: true, top6animationkeyform:top7animation}">
                <div v-for="(item, index) in bottonTableData" :key="index" v-bind:style="{ background: `url(${item.backgroundUrl}) 110px 290px no-repeat`,backgroundSize: `250px auto` }" :class="{itembox:true, norit: (index == 2 || index == 5), nobot:(index == 3 || index == 4 || index == 5)}" >
                    <div :class="{title:true, padTop: index == 3 || index == 4 ||index == 5 }"><img :src="item.icon" width="36px" alt=""> <span>{{item.title}}</span></div>
                    <div class="listcont" v-if="typeof(item.data) == 'object'">
                        <div v-show="index == 0" class="isAct" v-for="(it, ind) in item.data" :key="ind+10" @click="jiqiaoHandle(it)"><span> · </span>{{it.name}}</div>
                        <div v-show="index != 0" v-for="(it, ind) in item.data" :key="ind"><span v-show="item.data.length != 4"> · </span>{{it}}</div>
                        <div class="moreList" v-show="index == 2">
                            <div><span > · </span>软件测试</div>
                            <div><span > · </span>产品经理</div>
                            <div><span > · </span>Linux云计算+运维开发</div>
                            <div><span > · </span>智能机器人软件开发</div>
                            <div><span > · </span>电商视觉运营设计</div>
                            <div><span >   </span>…</div>
                        </div>
                        
                    </div>
                    <div class="listcont" v-else>{{item.data}}</div>
                </div>    
            </div>
        </div>
    </div>
    <bottom-widge></bottom-widge>
    <!-- <div style="position:fixed; top:0; z-index:20; left: 0; background:rgba(0,0,0,0.6); width:100%; height: 100vh;">
        weewrwerwer
        <pdf ref="pdf" :src="pdfurl" ></pdf>
    </div> -->
  </div>
</template>
<script>
// import { Content } from "../../../../graphql/ContentDetail.gql";
// import pdf from 'vue-pdf'
import navBarNoLab from "./../../../components/navBar";
import bottomWidge from "./../../../components/bottomWidge";
import { BisheSkillCourse } from "./../../../../gqlapi/BisheSkillCourse.js";
import { BisheProjecte } from "./../../../../gqlapi/BisheObjectes.js";
import { BisheObjectMaterial } from "./../../../../gqlapi/BisheObjectMaterial.js";
export default {
  components: {
    // pdf,
    navBarNoLab,
    bottomWidge,
  },
  data() {
    return {
        timer:null,
        fixdTop:false,
        top1animation:false,
        top2animation:false,
        top3animation:false,
        top4animation:false,
        top6animation:false,
        top61animation:false,
        top7animation:false,
        pg1animation:false,
        pg2animation:false,
        top3Index:0,
        scInd: 1,
        playerOptions: {
            playbackRates: [0.7, 1.0, 1.5, 2.0], 
            autoplay: true, 
            muted: false, 
            loop: true, 
            preload: 'auto', 
            language: 'zh-CN',
            aspectRatio: '16:9',
            fluid: true,
            sources: [{
                type: 'video/mp4', 
                src: 'https://v.itheima.net/b3s4xcsp.mp4' 
            }],
            poster: require('./images/video.jpeg'), 
            width: document.documentElement.clientWidth, 
            notSupportedMessage: '此视频暂无法播放，请稍后再试', 
            controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true 
            }
        },
        top3data: [
            {id: 0, title:'开题阶段', cont: [
                {icon: require('./images/img_bishexuanti.svg'), name: '毕设选题指导', desc: '介绍选题注意事项及选题技巧'},
                {icon: require('./images/icon_renwshu.svg'), name: '任务书', desc: '提供任务书模板'},
                {icon: require('./images/icon_kaitibaogao.svg'), name: '开题报告', desc: '提供开题报告模板及撰写建议'},
                // {icon: require('./images/icon_qitaziliao.svg'), name: '其他资料', desc: '提供参考文献、项目相关资料'},
            ]},
            {id: 1, title:'中期检查阶段', cont: [
                {icon: require('./images/icon_bishezhiliang.png'), name: '毕设质量', desc: '提供专业项目指导'},
                {icon: require('./images/icon_jianchazhidian.png'), name: '检查指点', desc: '提供中期检查表模板'},
            ]},
            {id: 2, title:'论文阶段', cont: [
                {icon: require('./images/img_lunwenziliao.png'), name: '论文资料', desc: '提供优秀论文100 套'},
                {icon: require('./images/icon_kaitibaogao.png'), name: '论文指导', desc: '提供论文模板及指导建议'},
                {icon: require('./images/icon_chachongjiqiao.png'), name: '查重技巧', desc: '提供修改套路及技巧'},
                {icon: require('./images/icon_lunwenyanshou.png'), name: '论文验收', desc: '提供论文格式修改技巧'},
            ]},
            {id: 3, title:'答辩阶段', cont: [
                {icon: require('./images/icon_dabianbaozhang.png'), name: '答辩保障', desc: '提供PPT及答辩技巧'},
                {icon: require('./images/icon_jicon_bishehuhang.png'), name: '毕设护航', desc: '确保毕设内容专业、技术领先'},
            ]},
        ],
        bottonTableData:[
            {icon: require('./images/icon_pinpai.svg'), title: '旗下品牌', data: [{name: '黑马程序员',url:'http://www.itheima.com/'},{name: '博学谷',url:'https://www.boxuegu.com/'},{name: '传智汇',url:'http://www.itczh.com/'},{name: '酷丁鱼少儿编程',url:'https://www.kudingyu.com/'},{name: '传智专修学院',url:'http://www.czxy.com/'},{name: '院校邦',url:'http://www.ityxb.com/'}], backgroundUrl: require('./images/img_ourbrands.png') },
            {icon: require('./images/icon_xiaoqu.svg'), title: '直营校区', data: '北京、天津、上海、广州、深圳、厦门、 武汉、重庆、西安、成都、长沙、合肥、 南京、济南、郑州、石家庄、太原、 沈阳、杭州', backgroundUrl: require('./images/img_Retailcampus.png') },
            {icon: require('./images/icon_xueke.svg'), title: '开设学科', data: ['JavaEE','大数据','HTML&JS+前端','Python+数据分析','人工智能开发','UI/UE设计','新媒体+短视频直播运营'], backgroundUrl: require('./images/img_Opendiscipline.png') },
            {icon: require('./images/icon_hezuo.svg'), title: '企业合作', data: ['华为 百度 IBM 金山云 红象云腾','库柏特机器人 中国软件 上海开放大学','清华大学出版社 中国铁道出版社','中国邮电出版社'], backgroundUrl: require('./images/img_Businesscooperation.png') },
            {icon: require('./images/icon_shili.svg'), title: '我们的实力', data: ['亿元级投资','引入企业技术','三大教学方法','不断提高行业标准','深耕IT教育14年','累计输出30万+人才','每20名从业者就有1名是我们培养'], backgroundUrl: require('./images/img_OurStrength.png') },
            {icon: require('./images/icon_yaunxiao.svg'), title: '院校合作', data: ['编著计算机教材：111本','教材发行总量：384万余册','覆盖全国高校生：200余万','教材覆盖全国高校：1904余所','占全国近3000所高校：50％以上'], backgroundUrl: require('./images/img_universitiescoopera.png') },
        ],
        materialData:[
            {title: '大型医院预约挂号管理系统', cont:'医院门诊挂号系统，为医院能够高效的诊疗服务提供信息化支持。', url:''},
            {title: '冷链仓储设备管理系统', cont:'本系统是一款应用于食品生鲜、医药冷链的仓储、运输环节中针对温度、湿度、电量等进行监控、预警和统计分析的系统。', url:''},
            {title: '酒店信息查询系统', cont:'酒店信息查询系统是一个酒店查询引擎，通过对全网各平台查询结合平台自身评价算法帮助用户找出最优酒店。', url:''},
            {title: '进出口贸易物流管理系统', cont:'本系统主要为中小企业解决货代出口存在的问题。国际物流业务闭环涉及多个关联方，可通过本系统建立连接，完成信息的流转。', url:''},
            {title: '某电商管理后台系统', cont:'电商通用解决方案，可帮助用户快速搭建一套电商系统，实现商品的管理、分类管理、物流等内容，为业务启动提供保障。', url:''},
            {title: '广告素材管理系统', cont:'广告企业主可通过本系统在平台上传广告、投放素材，广告系统可以根据广告平台自动匹配相应的广告素材。', url:''},
            {title: '在线教育平台课程管理系统', cont:'在线教育平台系统是针对在线教育企业推出的在线学习平台，用户可以登录平台完成平台上传的课程学习，并可对课程进行打分操作。', url:''},
            {title: 'IT资讯社区系统设计与实现', cont:'IT资讯社区，包含精品问答、技术论坛、公司招聘、资源下载等功能模块，致力于搭建原创、优质、完整的IT技术开发社区。', url:''},
        ],
        courseListData: [
            {icon: {url:require('./images/icon_kaitijieduan.svg')}, icontitle:'开题阶段', courseList: [{title: '如何找到一个靠谱的毕设题目？', image: {url:require('./images/kc7.png')}},{title: '开题报告的撰写套路',  image: {url: require('./images/kc12.png')}},{title: '开题报告注意事项全解析',  image: {url:require('./images/kc10.png')}}]},
            {icon: {url:require('./images/icon_kaifajieduan.png')}, icontitle:'开发阶段', courseList: [{title: '论文撰写全解析', image: {url:require('./images/kc15.png')}},{title: '毕设项目难点讲解',  image: {url: require('./images/kc14.png')}},{title: '如何进行系统测试及部署',  image: {url:require('./images/kc8.png')}},{title: '论文修改及查重必过套路',  image: {url:require('./images/kc5.png')}}]},
            {icon: {url:require('./images/icon-dabianjieduan.png')}, icontitle:'答辩阶段', courseList: [{title: '答辩PPT注意事项讲解', image: {url:require('./images/kc9.png')}},{title: '答辩讲解难点全解析',  image: {url: require('./images/kc11.png')}},{title: '答辩技巧揭秘', image: {url:require('./images/kc13.png')}}]}
        ],
        bsPageDage:[
            {
                bisheProjectHeand: {imgurl: {url:require('./images/demo1.jpg')}, title: '《乐悠商城项目-毕业设计》', label: '毕设完成的同时，技术能力同步升级', desc: '乐优商城是一个高性能，全品类的电商购物网站（B2C）。系统完整的实现了电商在线交易的全部功能，可以支撑高并发请求访问。使得中小企业可以直接部署上线，一些特定功能定制，只需要极小的二次开发成本。系统高效稳健运行，为企业的在线交易口碑做了有效的保障。'}, 
                contdata: [
                    {icon:require('./images/icon_kechenglinagdian.svg'), type:1, title: '课程亮点简介', cont: [
                        {name: '技术新颖', data: ['所包含技术列表：',' - SpringCloud使用的组件有：eureka，gateway，ribbon，hystrix，feign，springBoot等进行服务管理及调度',' - Mybatis-plus：操作数据库',' - ElasticSearch：实现实时搜索系统','- RabbitMQ：消息异步通讯',' - OpenResty：实现详情页生成',' - Canal：监控数据库，无耦合实现缓存数据刷新',' - Seata：分布式事务解决方案']},
                        {name: '业务完整，真实', data: '完整的电商购物系统，实现从商品管理到用户购买的完整业务闭环，真正的企业级真项目。真实的电商数据库设计，解决了全品类电商的SPU和SKU管理'},
                        {name: '解决方案可迭代性强', data: '整体电商还处于高速发展中阶段，本项目基本解决了大多数中小企业从0到有的问题，避免了从0开发方案设计，及前期落地巨大的支出问题，可以直接利用SpringCloud的技术可拔插对系统进行无缝升级，后期加入分布式日志，以及链路追踪，可以使得系统的错误定位能力，以及排错效率大幅提升'}]
                    },
                    {icon:require('./images/icon_peitaoziliao.svg'),type:2, title: '配套资料预览', cont: [{name:'开题报告',icon:require('./images/icon_kaitibao.svg'),url:'./files/黑马智慧物业管理答辩PPT.pdf'}, {name:'产品需求设计文档',icon:require('./images/icon_kaitibao.svg'),url:''}, {name:'概要设计',icon:require('./images/icon_kaitibao.svg'),url:''}, {name:'表结构图',icon:require('./images/icon_kaitibao.svg'),url:''}, {name:'毕设报告',icon:require('./images/icon_kaitibao.svg'),url:''}, {name:'答辩PPT',icon:require('./images/icon_kaitibao.svg'),url:''}]
                    },
                    {icon:require('./images/icon_zhuanyenandian.svg'),type:3, title: '专业难点技术解读', cont: [
                        {name: 'NodeJS精讲课助推技能新升级', imgurl:require('./images/kc2.png'), url:'http://yun.itheima.com/course/473.html'},
                        {name: '深度掌握Springboot实践技术教程', imgurl:require('./images/kc3.png'), url:'http://yun.itheima.com/course/471.html'},
                        {name: '4天从浅入深精通SpringCloud 微服务架构', imgurl:require('./images/kc1.png'), url:'http://yun.itheima.com/course/600.html'},
                        {name: 'java进阶教程RabbitMQ深入浅出', imgurl:require('./images/kc6.png'), url:'http://yun.itheima.com/course/714.html'},
                        {name: 'Redis入门到精通', imgurl:require('./images/kc16.png'), url:'http://yun.itheima.com/course/611.html'},]
                    },
                ]
            }
        ],
        swiperOption: {
            slidesPerView: 'auto',
            spaceBetween: 25,
            slidesPerGroup: 2,
            loop: false,
            loopFillGroupWithBlank: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                disabledClass: "swiper-button-disabled-class",
            },
        },
    };
  },

  created() {
    this.scInd = 2
    this.getBisheSkillCourse()
    this.getBisheProjecte()
    this.getBisheObjectMaterial()
  },
  methods:{
    handleScroll(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        let aimsId1 = document.querySelector('#scrollLab1');
        let aimsId2 = document.querySelector('#scrollLab2');
        let aimsId3 = document.querySelector('#scrollLab3');
        let aimsId4 = document.querySelector('#top3Position');
        let aimsId6 = document.querySelector('#screen6');
        let aimsId7 = document.querySelector('#screen7');
        if (scrollTop >= 10){
            this.top1animation = true
        }
        if (scrollTop >= 700){
            this.top2animation = true
        }
        if (scrollTop >= aimsId4.offsetTop-768){
            this.top3animation = true
            this.top4animation = true
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                if (this.top3Index >= 3 ) {
                    this.top3Index = 0
                } else {
                    this.top3Index++
                }
            }, 2000)
        }
        if(scrollTop >= aimsId6.offsetTop - 768){
            this.top6animation = true
        }
        if(scrollTop >= aimsId6.offsetTop - 168){
            this.top61animation = true
        }
        if(scrollTop >= aimsId7.offsetTop - 768){
            this.top7animation = true
        }
        
 
        if(scrollTop >= aimsId1.offsetTop - 70) { 
            this.fixdTop = true;
        } else {
            this.fixdTop = false;
        }
        if(scrollTop >= aimsId2.offsetTop - 70 && scrollTop < aimsId3.offsetTop-110 ){
            this.scInd = 2
        } else if(scrollTop >= aimsId3.offsetTop - 110){
            this.scInd = 3
        } else {
            this.scInd = 1
        }
    },
    scrollAimsHandle(aims){
        let aimsId1 = document.querySelector('#scrollLab1');
        let aimsId2 = document.querySelector('#scrollLab2');
        let aimsId3 = document.querySelector('#scrollLab3');
        switch(aims){
            case 1: {
                window.scrollTo({ 'top': aimsId1.offsetTop - 70, 'behavior': 'smooth' }) 
                break;
            }
            case 2: {
                window.scrollTo({ 'top': aimsId2.offsetTop, 'behavior': 'smooth' }) 
                break;
            }
            case 3: {
                window.scrollTo({ 'top': aimsId3.offsetTop-110, 'behavior': 'smooth' }) 
                break;
            }
        }
    },
    // openpdfHandle(url){
    //     this.pdfurl = url
    // },
    changeHandle(ind){
        this.top3Index = ind
    },
    overHandle(){
        clearInterval(this.timer)
    },
    // 技巧课程篇点击事件
    jiqiaoHandle(item){
        if (item.url != null) {
            window.open(item.url, "_blank");
        }
    },
    outHandle(){
        clearInterval(this.timer)
        this.timer = setInterval(() => {
            if (this.top3Index >= 3 ) {
                this.top3Index = 0
            } else {
                this.top3Index++
            }
        },2000)
    },
    qimoChatClick(name) {
      this.$trackEvent(name, "点击图标", name);
      window.qimoChatClick();
    },
    // 技巧课程篇数据获取
    getBisheSkillCourse() {
    //   this.$apollo.query({
    //       query: BisheSkillCourse,
    //     })
        this.$axios.post('/api',{
            operationName: "BisheSkillCourse",
            query: BisheSkillCourse
        })
        .then((res) => {
          this.courseListData = res.data.data.bisheSkillCourses
        });
    },
    // 项目数据获取
    getBisheProjecte() {
    //   this.$apollo.query({
    //       query: BisheProjecte,
    //     })
        this.$axios.post('/api',{
            operationName: "BisheProjecte",
            query: BisheProjecte
        })
        .then((res) => {
          const data = res.data.data.bisheProjectes
          data.map((item) => {
              if (item.contdata[0].cont[0].subTitle === 'list' && typeof item.contdata[0].cont[0].description === 'string'){
                  item.contdata[0].cont[0].description = item.contdata[0].cont[0].description.split('|')
              }
          })
          this.bsPageDage = data
        });
    },
    // 项目素材篇数据获取
    getBisheObjectMaterial() {
    //   this.$apollo.query({
    //       query: BisheObjectMaterial,
    //     })
        this.$axios.post('/api',{
            operationName: "BisheObjectMaterial",
            query: BisheObjectMaterial
        })
        .then((res) => {
          this.materialData = res.data.data.bisheObjectMaterials
        });
    },
    
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    // window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style >
.vjs-custom-skin > .video-js .vjs-big-play-button{
    width: 73px;
    height: 73px;
    border-radius: 73px;
    background-color: rgba(255,255,255,0.8);
    border:none;
    margin-left: -36px;
}
.vjs-modal-dialog .vjs-modal-dialog-content, .video-js .vjs-modal-dialog, .vjs-button > .vjs-icon-placeholder:before, .video-js .vjs-big-play-button .vjs-icon-placeholder:before{
    color:black;
}
</style>
<style lang="scss" scoped>
$maxwidth: 1180px;
$font1: 12px;
$font2: 14px;
$font3: 16px;
$font4: 18px;
$font5: 22px;
$fontTit1: 36px;
$fontTit2: 32px;
$titColor: #191C3D;
.bishe{
    min-width: $maxwidth;
    width: 100%;
    font-family:'PingFangSC', '微软雅黑';
    .swiper-container{
        padding:0px !important;
    }
    .swiper-button-prev{
        right: 40px !important;
    }
    .swiper-button-prev, .swiper-button-next{
        position:  relative !important;
        width: 20px !important;
        height: 20px !important;
        border-radius: 20px;
        background: none !important;
        border:none !important;
        color: #a3a6b3 !important;
        margin: 0 !important;
        top:0 !important;
        font-size: 18px !important;
    }
    .swiper-button-prev{
        left: 0px !important;
    }
    .swiper-button-next{
        right: 0px !important;
    }
    .swiper-button-prev:hover, .swiper-button-next:hover{
        transform: none;
        width: 20px !important;
        height: 20px !important;
        border-radius: 20px !important;
        background: none !important;
        border:none !important;
        color: #37a7a4 !important;
    }
    .swiper-button-prev:active, .swiper-button-next:active{
      color: #0b8669 !important;
    }
    .swiper-button-prev:focus, .swiper-button-next:focus{
      outline: none;
    }
  .content{
    .top1{
        background: #fff;
        .banner{
            position: relative;
            background: url('./images/bj_banner.jpg') center center no-repeat;
            background-size: cover;
            height: 530px;
            text-align: center;
            // img{
            //     width: 737px;
            //     position: relative;
            //     left:-200px;
            //     top: 150px;
            //     z-index: 8;
            // }
            &::after{
                content: '';
                position: absolute;
                bottom: -120px;
                left: 0;
                background: url('./images/img_caidai.png') center bottom no-repeat;
                height: 400px;
                width: 100%;
                background-size: contain;
            }
        }
        .title{
            font-size: $fontTit1;
            color:$titColor;
            margin: 85px 0 65px 0;
            line-height: 50px;
            font-weight: bold;
            text-align: center;
            position: relative;
            &::before{
                width: 50px;
                height: 3px;
                border-radius: 3px;
                content: '';
                position: absolute;
                bottom: -20px;
                left: 50%;
                transform: translateX(-50%);
                background: #19B690;
                border-radius: 3px;
            }
        }
        .cont{
            margin: 0 auto;
            display: flex;
            max-width:1570px;
            width: 90%;
            justify-content: center;
            .play{
                position: relative;
                z-index: 9;
                flex: 72;
                border:solid 10px #f0f0f0;
                border-radius: 4px;
                img{
                    width: 100%;
                }
            }
            .leftcont,.ritcont{
                flex: 42;
                padding: 0px;
                img{
                    position: relative;
                    width: 100%;
                    opacity: 0;
                }
                .tit{
                    font-size: 22px;
                    font-weight: bold;
                }
                span{
                    display: inline-block;
                    background: #f0f0f0;
                    color: #6D707E;
                    padding:20px;
                    img{
                        width: 20px;
                        height: 20px;
                        border-radius: 20px;
                    }
                }
            } 
        }
        .top1animationkey{
            .leftcont{
                img{
                    animation: top1keyleft 800ms  forwards;
                }
            }
            .ritcont{
                img{
                    animation: top1keyrit 800ms  forwards;
                }
            }
        }
    }
    .top2{
        background: #fff;
        padding: 40px 0 0 0;
        .placeholderbox{
            background: #fff;
            height: 70px;
        }
        .topTit{
            margin: 0 auto;
            width: 100%;
            background: #fff;
            // display: flex;
            text-align: center;
            font-size: 18px;
            padding-bottom: 20px;
            z-index: 10;
            position: relative;
            .box{
                width: 1180px;
                display: flex;
                margin: 0 auto;
                color: #6D707E;
            }
            div{
                position: relative;
                flex: 1;
                line-height: 50px;
                cursor: pointer;
            }
            .act{
                color:#191C3D;
                &::after{
                    content: '';
                    display: inline-block;
                    width: 44px;
                    height: 11px;
                    position: absolute;
                    bottom:-8px;
                    left: 50%;
                    transform: translateX(-50%);
                    background: url('./images/icon_dingwei.png') center center no-repeat;
                    background-size: 44px 11px;
                }
                
            }
        }
        .scrollTop{
            position: fixed;
            top: 0px;
        }
        .content{
            background: #f4f6fb;
            padding-bottom: 1px;
            text-align: center;
            .cont{
                min-height: 300px;
                width: $maxwidth;
                margin: 0 auto;
                // padding-top: 50px;
                position: relative;
                min-height: 840px;
                .title{     
                    position: relative;
                    font-size: $fontTit1;
                    font-weight: bold;
                    line-height: 50px;
                    margin: 5px 0px 57px 0;
                    color:$titColor;
                    img{
                        position: relative;
                        top:4px;
                    }
                    &::after{
                        content: '';
                        position: absolute;
                        left: 50%;
                        bottom:-20px;
                        width: 50px;
                        height: 1px;
                        border-bottom: 3px solid #19b690;
                    }
                }
                .itemBox{
                    font-family: 'PingFangSC','微软雅黑';
                    position: relative;
                    cursor: pointer;
                    .item{
                        display: flex;
                        padding: 20px 0 50px 0;
                        position: relative;
                        .icon{
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            margin-right: 80px;
                            font-size: $font3;
                            line-height: 30px;
                            position: relative;
                            top: -15px;
                            opacity: 0;
                            img{
                                display: inline;
                            }
                            &::after{
                                content: '';
                                width: 6px;
                                height: 6px;
                                position: absolute;
                                right: -39px;
                                background: #19b690;
                                border: 3px solid #adebdc;
                                border-radius: 50%;
                            }
                        }
                        .itemInfo{
                            position: relative;
                            font-size: $font3;
                            line-height: 30px;
                            margin-right:50px ;
                            width: 206px;
                            overflow: hidden;
                            // font-size: 14px;
                            opacity: 0;
                            text-align: left;
                            img{
                                border-radius: 6px;
                            }
                        }
                        .itemInfolast{
                            margin-right:0px;
                        }
                    }
                }
                .line{
                    // height: 100%;
                    height: 919px;
                    border-right: dashed 2px #ccc;
                    // border-image: -webkit-linear-gradient(#f4f4f4 , #ccc , #f4f4f4)1 10 1;
                    position: absolute;
                    left:95px;
                    top:5%;
                    width: 1px;
                    &::after{
                        content: '';
                        width: 6px;
                        height: 150px;
                        position: absolute;
                        top:0px;
                        background:linear-gradient(rgba(244,246,251,0.9), rgba(244,246,251,0.6)) ;
                    }
                    &::before{
                        content: '';
                        width: 6px;
                        height: 150px;
                        position: absolute;
                        bottom:0px;
                        background:linear-gradient( rgba(244,246,251,0.6),rgba(244,246,251,0.9)) ;
                    }
                }
            }
            .top2animationkey{
                .icon{
                    animation: top2keyfromicon 500ms  ease-in forwards;
                }
                .itemInfo[dataind = '00']{
                    animation: top2keyfrom 700ms ease-in forwards;
                }
                .itemInfo[dataind = '01']{
                    animation: top2keyfrom 700ms  ease-in forwards;
                }
                .itemInfo[dataind = '02']{
                    animation: top2keyfrom 700ms  ease-in forwards;
                }
                .itemInfo[dataind = '10']{
                    animation: top2keyfrom 700ms 500ms ease-in forwards;
                }
                .itemInfo[dataind = '11']{
                    animation: top2keyfrom 700ms 500ms ease-in forwards;
                }
                .itemInfo[dataind = '12']{
                    animation: top2keyfrom 700ms 500ms ease-in forwards;
                }
                .itemInfo[dataind = '13']{
                    animation: top2keyfrom 700ms 500ms ease-in forwards;
                }
                .itemInfo[dataind = '20']{
                    animation: top2keyfrom 700ms 1200ms ease-in forwards;
                }
                .itemInfo[dataind = '21']{
                    animation: top2keyfrom 700ms 1200ms ease-in forwards;
                }
                .itemInfo[dataind = '22']{
                    animation: top2keyfrom 700ms 1200ms ease-in forwards;
                }
            }
            .bottom{
                width: 100%;
                height: 260px;
                background: url('./images/img_bj_sidai.svg') center center no-repeat;
                background-size: cover;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                // margin-bottom: 50px;
                position: relative;
                top: -90px;
                .tit{
                    position: relative;
                    top:20px;
                    font-size: $fontTit1;
                    font-weight: bold;
                    color:$titColor;
                    img{
                        position: relative;
                        top: 8px;
                        display: inline;
                        line-height: 50px;
                    }
                }
                .desc{
                    position: relative;
                    top:30px;
                    color: #6D707E;
                    font-size: 18px;
                    // line-height: 65px;
                    padding: 13px 0 0px 0;
                }
            }
        }

    }
    .top3{
        background: url('./images/img_bj_xaingmukecheng.jpg') center center no-repeat;
        background-size: cover;
        height: 510px;
        .titleCont{
            height: 200px;
            padding: 40px 50px 100px 50px;
            display: flex;
            flex-direction: column;
            width: 1080px;
            margin: 0 auto;
            color: #fff;
            .label{
                display: flex;
                text-align: center;
                position: relative;
                line-height: 100px;
                height: 100px;
                font-size: 22px;
                font-weight: bold;
                display:-webkit-box;
                span{
                    flex: 1;
                    position: relative;
                    display: block;
                    height: 100px;
                    cursor: pointer;
                    &::after{
                        content: '';
                        bottom:-4px;
                        width: 9px;
                        height: 9px;
                        background: #fff;
                        border-radius: 50%;
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        z-index: 3;
                        // border: 3px solid rgba(0,0,0,0.1);
                    }
                }
                .act{
                    color:#3BE8BE; 
                    &::after{
                        bottom:-6px;
                        background: #3BE8BE;
                        background: #3BE8BE;
                         border: 3px solid #adebdc;
                        box-shadow: 0 0 3px #adebdc;
                        border-radius: 50%;
                    }
                }
                &::after{
                    content: '';
                    top:98px;
                    left: 50%;
                    transform: translateX(-50%);
                    border-bottom: dashed 1px rgba(255,255,255,0.55);
                    width: 815px;
                    height: 1px;
                    position: absolute;
                }
            }
            .cont{
                display: flex;
                text-align: center;
                position: relative;
                opacity: 0;
                .labbox{
                    position: relative;
                    
                    padding: 80px 0 60px 0;
                    flex:1;
                    .tit{
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 70px;
                    }
                    .des{
                        font-size: $font3;
                        line-height: 14px;
                    }
                }
            }
        }
        .top3animationkeyfrom{
                animation: top3keyfromicon 500ms  ease-in forwards;
        }
    }
    .top4{
        position: relative;
        top: 0px;
        background: url('./images/img_bj_sidai.svg') center 40% no-repeat;
        background-size: contain;
        .content{
            width: 1080px;
            margin: 0 auto 30px auto;
            background: #fff;
            border-radius: 10px;
            padding: 50px;
            .conthead{
                display: flex;
                text-align: left;
                font-size: 16px;
                padding-bottom: 20px;
                img{
                    margin-right: 40px;
                    border-radius: 6px;
                }
                .title{
                    font-size: 32px;
                    line-height: 64px;
                    font-weight: bold;
                    position: relative;
                    left: -10px;
                    color:$titColor;
                    
                }
                .label{
                    margin: 15px 0 10px 0;
                    span{
                        background: #ffe7c9;
                        border: 1px solid #daac71;
                        border-radius: 6px;
                        padding: 6px 8px;
                        color: #DAAC71;
                        img{
                            position: relative;
                            top: 6px;
                            margin-right:4px;
                        }
                    }
                }
                .desc{
                    line-height: 30px;
                    padding-top:10px;
                    color:#6D707E;
                }
            }
            .block{
                border-radius: 8px;
                // box-shadow: 0px 1px 2px 2px rgba(231,231,231,0.30); 
                padding: 40px 40px 0px 40px;
                background: #f1f3f8;
                .blockItem{
                    line-height: 24px;
                    .bk1, .bk2, .bk3{
                        padding-top:20px;
                        .tit{
                            font-size: 20px;
                            font-weight: bold;
                            line-height: 70px;
                            color:$titColor;
                            img{
                                margin-right: 20px;
                                display: inline-block;
                                position: relative;
                                top:15px;
                                left: 5px;
                            }
                        }
                        .cont{
                            margin-left: 70px;
                            padding-bottom:40px;
                            border-bottom: dashed 2px #cfcfd6;
                            line-height: 30px;
                            color:#6D707E;
                        }
                    }
                    .bk1{
                        padding-top:6px;
                        .name{
                            color:#DAAC71;
                            line-height: 40px;
                            font-weight: bold;
                            margin-top: 6px;
                        }
                    }
                    .bk2{
                        .cont{
                            // display: flex;
                            .listbox{
                                position: relative;
                                text-align: center;
                                background: #fff;
                                border: 1px solid #dcdde0;
                                border-radius: 4px;
                                padding: 0px 11px;
                                margin: 10px 20px 10px 0px;
                                font-size: 14px;
                                cursor: pointer;
                                display: inline-block;
                                .lab{
                                    color: #6D707E;
                                    img{
                                        position: relative;
                                        top: 3px;
                                        left: -3px;
                                        color:#6D707E;
                                    }
                                }
                                &:hover{
                                    background: #f3f3f3;
                                }
                                &>.st:hover{
                                    &::before{
                                        position: absolute;
                                        top: -40px;
                                        left:50%;
                                        transform: translateX(-50%);
                                        content: '点击查看详情';
                                        color:#fff;
                                        background: #000;
                                        width: 104px;
                                        line-height: 28px;
                                        opacity: 0.8;
                                        font-size: 14px;
                                        border-radius: 4px;
                                    }
                                }
                                &>.none:hover{
                                    &::before{
                                        position: absolute;
                                        top: -40px;
                                        left:50%;
                                        transform: translateX(-50%);
                                        content: '不支持预览，可向咨询获取';
                                        color:#fff;
                                        background: #000;
                                        width: 204px;
                                        line-height: 28px;
                                        opacity: 0.8;
                                        font-size: 14px;
                                        border-radius: 4px;
                                    }
                                }
                            }
                        }
                        
                    }
                    .bk3{
                        .tit{
                            display: flex;
                            justify-content: space-between;
                            .rowBut{
                                width: 60px;
                                top:5px;
                                right: -3px;
                                position: relative;
                                display: flex;
                                justify-content: space-between;
                            }
                        }
                        .cont{
                            // display: flex;
                            border:none;
                            .list{
                                margin-right: 20px;
                                // width: 168px;
                                line-height: 24px;
                                img{
                                    width: 100%;
                                    margin-bottom:10px;
                                    border-radius: 8px;
                                }
                            }
                        }
                    }
                }
            }
            .buttom{
                    text-align: center;
                    color: #fff;
                    font-size: 14px;
                    padding-top:40px;
                    span{
                        display: inline-block;
                        width: 140px;
                        padding: 15px 30px;
                        background: #19b690;
                        margin:10px 20px;
                        border-radius: 25px;
                        box-shadow: 0px 2px 11px 1px rgba(20,128,102,0.24);
                        cursor: pointer;
                    }
                    .butleft{
                        background: #19b690;
                        box-shadow: 0px 2px 11px 4px rgba(20,128,102,0.24); 
                        &:hover{
                           background: #3CDAB4;
                        }
                        &:active{
                            background: #0B8669;
                        }
                    }
                    .butrit{
                        background: #D19B55;
                        box-shadow: 0px 2px 11px 4px rgba(114,82,41,0.13); 
                        &:hover{
                           background: #EABB7F;
                        }
                        &:active{
                            background: #AD742A;
                        }
                    }
                    a{
                        color: #fff;
                    }
                }
        }
        .noneBut{
            margin-bottom: 0px !important;
        }
    }
    .top4animationkeyfrom{
           animation: top4keyfromicon 500ms 1s ease-in forwards;
        }
    .noMargin{
        margin: 0 !important;
    }
    .top6{
        text-align: center;
        .topBanner{
            background: url(./images/ing_bg_shipinku.jpg) center center no-repeat;
            background-size:cover;
            height: 380px;
            display: flex;
            flex-direction:column;
            justify-content: center;
            position: relative;
            padding-top: 30px;
            .contInfo{
                opacity: 0;
                position: relative;
            }
            span{
                position: relative;
                top:15px;
                background: #d19b55;
                border-radius: 25px;
                display: inline-block;
                width: 164px;
                line-height: 50px;
                // padding: 12px 40px;
                text-align: center;
                color: #fff;
                font-size: $font3;
                margin: 40px;
                &:hover{
                    background: #EABB7F;
                }
                &:active{
                    background: #AD742A;
                }
            }
        }
        .contbox{
            .title{     
                margin-top: 82px;
                position: relative;
                font-size: $fontTit1;
                font-weight: bold;
                color:$titColor;
                img{
                    position: relative;
                    top:5px;
                }
            }
            .desc{
                font-size: 18px;
                line-height: 60px;
                color:#6D707E;
                margin-bottom:50px;
                position: relative;
                top:10px;
            }
        }
        
        .itembox{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            width: $maxwidth;
            margin: 0 auto;
            position: relative;
            opacity: 0;
            .materiallist{
                background: #fff;
                box-sizing: border-box;
                // flex: 1 0 15%;
                width: calc(25% - 15px);
                padding: 20px;
                margin-right: 20px;
                margin-bottom: 20px;
                border-radius: 6px;
                box-shadow: 0px 1px 6px 2px rgba(231,231,231,0.50);
                .tit{
                    line-height: 50px;
                    font-size: 20px;
                    font-weight: bold;
                    color:$titColor;
                }
                .des{
                    text-align: left;
                    line-height: 32px;
                    color:#6D707E;
                    font-size: 16px;
                    min-height: 128px;
                    font-family:'PingFangSC', '微软雅黑';
                }
                .down{
                    padding-top: 20px;
                    cursor: pointer;
                    span{
                        display: inline-block;
                        background: #ffffff;
                        border: 1px solid #37c7a4;
                        border-radius: 25px; 
                        color: #37c7a4;
                        width: 124px;
                        line-height: 40px;
                        font-size: $font2;
                        &:hover{
                           background: #19B690;
                           border: 1px solid #19B690;
                           color:#fff;
                        }
                        &:active{
                            background: #0B8669;
                             color:#fff;
                        }
                    }
                }
            }
            .last{
                margin-right: 0;
            }
            .materiallistlast{
                position: relative;
                background: #fff;
                box-sizing: border-box;
                width: calc(25% - 15px);
                padding: 20px;
                margin-right: 0px;
                margin-bottom: 20px;
                border-radius: 6px;
                box-shadow: 0px 1px 6px 2px rgba(231,231,231,0.50);
                .des{
                    text-align: center;
                    padding-top: 50px;
                    line-height: 32px;
                    color:#6D707E;
                    font-size: 16px;
                    font-family:'PingFangSC', '微软雅黑';
                }
                .down{
                    padding-top: 52px;
                    cursor: pointer;
                    span{
                        display: inline-block;
                        background: #ffffff;
                        border: 1px solid #37c7a4;
                        border-radius: 25px; 
                        color: #37c7a4;
                        width: 124px;
                        line-height: 40px;
                        font-size: $font2;
                        &:hover{
                           background: #19B690;
                           border: 1px solid #19B690;
                           color:#fff;
                        }
                        &:active{
                            background: #0B8669;
                             color:#fff;
                        }
                    }
                }
                &::before{
                    content: '';
                    position: absolute;
                    width: 72px;
                    height: 74px;
                    right: 0px;
                    top:-1px;
                    background:url('./images/img_jiaobiao.png') top right no-repeat;
                    background-size:cover;    
                }
            }
            
        }
        .downloadBut{
            padding: 40px 0  50px 0;
            span{
                cursor: pointer;
                display: inline-block;
                background: #19b690;
                border-radius: 25px;
                box-shadow: 0px 2px 11px 1px rgba(20,128,102,0.24);   
                color:#fff;
                width: 212px;
                line-height: 50px;
                font-size:16px;
                &:hover{
                    background: #3CDAB4;
                }
                &:active{
                    background: #0B8669;
                }
            }
        }
    }
    .top6animationkeyform{
        animation: top3keyfromicon 500ms 300ms ease-in forwards;
    }
    .top61animationkeyform{
        animation: top3keyfromicon 500ms 400ms ease-in forwards;
    }
    .top62animationkeyform{
        animation: top3keyfromicon 500ms 500ms ease-in forwards;
    }
    .top7{
        background: url('./images/img_bj_us.jpg') center center no-repeat;
        background-size: cover;
        padding: 40px 0;
        position: relative;
        .title{
            font-weight: bold;
            text-align: center;
            color: #fff;
            font-size: $fontTit2;
            line-height: 80px;
            position: relative;
        }
        .padTop{
            padding-top:20px;
        }
        .label{
            opacity: 0;
            position: relative;
            text-align: center; 
            padding: 0px 20px 40px 20px;
            color: #fff;
            span{
                background: #FF5757;
                display: inline-block;
                padding:10px 25px;
                font-size: $font3;
            }
        }
        .contBox{
            background: #fff;
            padding: 30px;
            margin: 0 auto;
            width: 1120px;
            border-radius: 6px;
            display: flex;
            flex-wrap: wrap;
            position: relative;
            opacity: 0;
            .itembox{
                // width: calc(30% - 10px);
                flex: 1 0 25%;
                min-height: 285px;
                padding:0px 20px;
                color: #333;
                border-right: dashed 1px #dddbdb;
                border-bottom: dashed 1px #dddbdb;
                position: relative;
                .title{
                    text-align: left;
                    color:$titColor;
                    font-size: 20px;
                    line-height: 50px;
                    img{
                        position: relative;
                        top: 10px;
                    }
                }
                .listcont{
                    position: relative;
                    padding-left: 42px;
                    line-height: 40px;
                    color: #6D707E;
                    font-size: 14px;
                    min-height: 300px;
                    .isAct{
                        cursor: pointer;
                        &:hover{
                            color: #37c7a4;
                        }
                    }
                    .moreList{
                        position: absolute;
                        right: -10px;
                        top: 0px;
                    }
                }
                .bgHandle{
                    position: absolute;
                    width: 250px;
                    bottom:0px;
                    right:0
                }
            }
            .norit{
                border-right: none;
            }
            .nobot{
                border-bottom: none;
            }
        }
    }
  }
}
@keyframes top1keyleft {
    from {
        opacity: 0;
        left:-60px;
    }
    to {
        left:10px;
        opacity: 1;
    }
}
@keyframes top1keyrit {
    from {
        opacity: 0;
        left:60px;
    }
    to {
        left:-10px;
        opacity: 1;
    }
}


@keyframes top2keyfrom {
    from {
        opacity: 0;
        left:200px;
    }
    to {
        left:0px;
        opacity: 1;
    }
}
@keyframes top2keyfromicon {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
@keyframes top3keyfromicon {
    from {
        opacity: 0;
        top:50px;
    }
    to {
        opacity: 1;
        top:0;
    }
}
@keyframes top4keyfromicon {
    from {

        top:0px;
    }
    to {

        top:-40px;
    }
}
</style>
<style lang="scss">
.bannerKey{
    position: relative;
    top: 150px;
    width: 741px;
    left:50%;
    transform: translateX(-610px);
    z-index: 8;
    .rowA{
        position: relative;
        animation: rowA 400ms 500ms ease-out forwards;
        top:-500px;
    }
    .rowB{
        display: flex;
        padding:20px 0;
        img{
            margin-right:17px;
            position: relative;
            opacity: 0;
            left:500px;
        }
        .img1{
            animation: rowB 500ms 900ms ease-out forwards;
        }
        .img2{
            animation: rowB 500ms 1200ms ease-out forwards;
        }
        .img3{
            animation: rowB 500ms 1500ms ease-out forwards;
        }
        .img4{
            animation: rowB 500ms 1800ms ease-out forwards;
            margin-right:0;
        }
        
    }
    .rowC{
        position: relative;
        left: -10px;
        img{
           opacity: 0;
           width: 39px;
        }
        .imgfotn1{
            animation: rowB 100ms  2300ms ease-out forwards;
        }
        .imgfotn2{
            animation: rowB 100ms  2400ms ease-out forwards;
        }
        .imgfotn3{
            animation: rowB 100ms  2500ms ease-out forwards;
        }
        .imgfotn4{
            animation: rowB 100ms  2600ms ease-out forwards;
        }
        .imgfotn5{
            animation: rowB 100ms  2700ms ease-out forwards;
        }
        .imgfotn6{ animation: rowB 100ms  2800ms ease-out forwards; }
        .imgfotn7{ animation: rowB 100ms  2900ms ease-out forwards; }
        .imgfotn8{ animation: rowB 100ms  3000ms ease-out forwards; }
        .imgfotn9{ animation: rowB 100ms  3100ms ease-out forwards; }
        .imgfotn10{ animation: rowB 100ms  3200ms ease-out forwards; }
        .imgfotn11{ animation: rowB 100ms  3300ms ease-out forwards; }
        .imgfotn12{ animation: rowB 100ms  3400ms ease-out forwards; }
        .imgfotn13{ animation: rowB 100ms  3500ms ease-out forwards; }
        .imgfotn14{ animation: rowB 100ms  3600ms ease-out forwards; }
        .imgfotn15{ animation: rowB 100ms  3700ms ease-out forwards; }
        .imgfotn16{ animation: rowB 100ms  3800ms ease-out forwards; }
        .imgfotn17{ animation: rowB 100ms  3900ms ease-out forwards; }
        .imgfotn18{ animation: rowB 100ms  4000ms ease-out forwards; }
        .imgfotn19{ animation: rowB 100ms  4100ms ease-out forwards; }
    }
}
@keyframes rowA {
    from {
        top:-100px;
    }
    to {
        top:0px;
    }
}
@function animations(){

}

@keyframes rowB{
    from {
        opacity: 0;
        left:50px;
    }
    to {
        left:0px;
        opacity: 1;
    }
}

@keyframes rowC{
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

</style>
